export default "__VITE_ASSET__C$vFlo6r__"